/* eslint-disable import/no-anonymous-default-export */
export default {
  "project.new": "Nuevo proyecto",
  "project.edit": "Editar proyecto",
  "project.delete": "Eliminar proyecto",
  "project.add.title": "Crea un nuevo proyecto",
  "project.update.title": "Actualiza el proyecto",
  "project.name": "Nombre del proyecto",
  "project.description": "Descripción del proyecto",
  "project.details": "Detalles",
  "project.apply": "Aplicar",
  "project.name.message": "Por favor, ingresa el nombre del proyecto",
  "project.description.message":
    "Por favor, ingresa la descripción del proyecto",
  "project.stage": "Estado",
  "project.stage.message": "Por favor, selecciona un estado",
  "project.workNumber": "Código del proyecto",
  "project.workNumber.message": "Por favor, ingresa el código del proyecto",
  "project.workNumber.exists":
    "Ya existe un proyecto con el mismo código. ¿Deseas registrarlo de todas formas?",
  "project.revision": "Estilo de revisión aceptada",
  "project.revision.styles": "Estilos de revisiones permitidas",
  "project.revision.message": "Selecciona un estilo de revisión",
  "project.revision.numeric": "Numérica (Ej.: -R00; -R36; -R87)",
  "project.revision.doubleNumeric":
    "Doble Numérica (Ej.: -R00.00; -R00.01; -R01.00)",
  "project.revision.alphabetical": "Alfabética (Ej.: -RA; -RY; -RAG)",
  "project.revision.alert":
    "El estilo de revisión no puede ser alterado después de la creación del proyecto.",
  "project.link": "Enlace",
  "project.forum": "Foro",
  "project.company": "Empresa",
  "project.avatar": "Avatar",
  "project.form.data": "Datos del proyecto",
  "project.form.access": "Accesos del proyecto",
  "project.company.message": "Por favor, selecciona una empresa",
  "project.already.created": "Proyecto ya creado, por favor elige otro nombre",

  "project.stage.IN PROGRESS": "En progreso",
  "project.stage.INACTIVE": "Inactivo",
  "project.stage.DELIVERED": "Entregado",
  "project.stage.CHANGING": "En modificación",

  "project.stage.mode.message": "Selecciona un Estado",

  "project.emptyDataMessage.message": "Hola, aún no hay nada por aquí.",
  "project.emptyDataMessage.instructions":
    "¡Puedes comenzar creando un nuevo proyecto!",
  "project.emptyDataMessage.newProject": "+ Nuevo proyecto",
};
